module.exports = __webpack_public_path__ + "static/media/fig_8c.0aaaa121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_8c.jpg
// module id = 683
// module chunks = 0